module.exports = __webpack_public_path__ + "static/media/ic_snsja.e0e5bc2a.svg";